<template>

    <DxDataGrid
        ref="myDataGrid"
        :data-source="dataSource"
        @row-updating="updateRow"
        :repaint-changes-only="true"
        @row-removing="onRowRemoving"
        :swipeEnabled="true"
        @saving="onSaving"
        @cell-hover-changed="onCellHoverChanged"
        :sorting="{ mode: 'none'}"
        @selection-changed="selectionChanged"
        :focused-row-enabled="false"
        @init-new-row="onNewRow"
        >

        <DxScrolling
            show-scrollbar="true"    
        >
        </DxScrolling>

        <DxSelection mode="multiple" /> 

        <DxColumn
          data-field="tareaId"
          caption="Tarea"
          :allow-editing="true"
          :show-editor-always="true"
        >
          <DxLookup
            :data-source="cbTareas"
            value-expr="ta_Id"
            display-expr="ta_Nombre"
          />

          <DxValidationRule type="required"/>
        </DxColumn>

        <DxColumn 
          :visible="!tiempoDecimal"
          data-field="tiempo"
          :width=80
          data-type="datetime"
          :show-editor-always="true"
          :editor-options="edOpt"
          :allow-editing="true"
          format="HH:mm"
          header-cell-template="title-header-time">
        </DxColumn>

        <DxColumn 
          :visible="tiempoDecimal"
          data-field="tiempoInt"
          :width=80
          data-type="number"
          :show-editor-always="true"
          :editor-options="edOptDecimal"
          :allow-editing="true"
          header-cell-template="title-header-time">
        </DxColumn>
        <template #title-header-time>
          <div class="horaTitulo">
            <i class="bi bi-clock  text-center"></i>
          </div>
        </template> 
        <DxColumn
          data-field="property1"
          data-type="boolean"
          :width=50
          header-cell-template="title-header-money"
          >
        </DxColumn>
        <template #title-header-money>
          <i class="bi bi-coin"></i>
        </template>
        <DxColumn
          data-field="property2"
          data-type="boolean"
          :width=50
          header-cell-template="title-header-terrain"
          >
        </DxColumn>
        <template #title-header-terrain>         
          <i class="bi bi-sign-intersection-t"></i>
        </template>
        <DxColumn
          data-field="tareadesc"
          caption="Descripción"
          data-type="string"
          >
        </DxColumn>
        <DxColumn type="buttons">
        <DxButton
          icon="add"
          @click="onAddButtonClick"
        />
        <DxButton name="edit"/>
        <DxButton name="delete"/>
        <DxButton name="save"/>
        <DxButton name="cancel"/>
      </DxColumn>
        <DxEditing
            :allow-updating="allowEdicion"
            :allow-deleting="allowEdicion"
            :confirm-delete="userConfirmDelete"
            :texts="localizedEditTexts"
            :use-icons="true"
            refresh-mode="repaint"
            :select-text-on-edit-start="true"
            :mode="rowEditModeType[1]">
        </DxEditing>
    </DxDataGrid>

    <div class="add-task-row">
      <DxStandaloneButton
        icon="add"
        text="Agregar Tarea"
        styling-mode="text"
        @click="onAddNewTask"
      />
    </div>

    <DxTooltip
      :target="TooltipTarget"
      :visible="isToolTipVisible"
      content-template="toolTipTemplate"
      >
      <template #toolTipTemplate>
        <span>{{ TooltipText }}</span>
      </template>
    </DxTooltip>

</template>

<script setup>

import {  DxDataGrid,
          DxColumn,
          DxEditing, 
          DxSelection,
          DxScrolling, 
          DxButton,
          DxValidationRule,
          DxLookup, 
        } from 'devextreme-vue/data-grid';

import CustomStore from 'devextreme/data/custom_store'
import DataSource from 'devextreme/data/data_source'

import { DxTooltip } from 'devextreme-vue/tooltip'
import { DxButton as DxStandaloneButton } from 'devextreme-vue/button'

import { ref } from 'vue'
import { useAuthStore } from '../stores/auth.js'
import { useCatalogStore } from '../stores/catalog.js'

const authStore = useAuthStore()
const catalogStore = useCatalogStore()
import tokenService from '../utils/tokenService.js'
import { useTimesStore } from '../stores/times.js'

const timesStore = useTimesStore()

const userConfirmDelete = authStore.confirmDelete == 1 ? true : false

const isToolTipVisible = ref(false)
const TooltipTarget = ref(null)
const TooltipText = ref(null)

const myDataGrid = ref()
const updateObject = ref()

const rowEditModeType = [
  'row',
  'cell' 
]

const tiempoDecimal = authStore.timeTipo == 1

const edOpt = {
  'type': "time",
  'pickerType': "list",
  'displayFormat': "HH:mm",
  'interval': 30
}

const edOptDecimal = {
  'type': "number",
  'format': "00.00"
}

const props = defineProps({
    templateData: { type: Object },
    gridinstance: { type: Object },
    onDonutRefresh: { type: Function },
    user: { type: String },
    hoy: { type: Date },
    selectedData: { type: Array},
})

const baseUrl = import.meta.env.VITE_API_BASE_URL + '/'

// D2: sin esto, una hora contra un ítem de presupuesto o una tarea no
// presupuestada vuelve de v_TimeSheet con tareaId null (ver
// encodeTareaId/decodeTareaId en catalog.js) - se veía como una fila con la
// tarea en blanco, típicamente después de una reasignación de horas.
catalogStore.ensureImputables(props.templateData.data.ts_ProjectId)

const selectedItemKeys = ref(null)

const localizedEditTexts = {
    confirmDeleteMessage: '¿Esta seguro que desea eliminar esta información?'
}

const siTareaId = ref(false)

function onNewRow(e) {
  e.data.ts_ProjectId = selectedItemKeys.value.ts_ProjectId
  e.data.ts_Tipo = selectedItemKeys.value.ts_Tipo
  e.data.ts_Fecha = selectedItemKeys.value.ts_Fecha
  e.data.ts_UserCognito = selectedItemKeys.value.ts_UserCognito
  e.data.tiempoInt = 0
  e.data.tiempo = ''
  e.data.property1 = 0
  e.data.property2 = 0
  e.data.tareadesc = ''
}

function onAddButtonClick(e) {
  selectedItemKeys.value = e.row.data
  myDataGrid.value.instance.addRow()
}

function onAddNewTask() {
  selectedItemKeys.value = {
    ts_ProjectId: props.templateData.data.ts_ProjectId,
    ts_Tipo: props.templateData.data.ts_Tipo,
    ts_Fecha: props.templateData.data.ts_Fecha,
    ts_UserCognito: props.templateData.data.ts_UserCognito
  }
  myDataGrid.value.instance.addRow()
}


function onCellHoverChanged(e) {
  if (e.rowType === 'header'  && e.column.dataField === 'tiempo'){
    TooltipTarget.value = e.cellElement
    if (e.eventType === 'mouseover') {
        TooltipText.value = 'Horas'
        isToolTipVisible.value = true
    }
    if (e.eventType === 'mouseout') {
        TooltipText.value = ''
        isToolTipVisible.value = false
    }
  }
  if (e.rowType === 'header'  && e.column.dataField === 'tiempoInt'){
    TooltipTarget.value = e.cellElement
    if (e.eventType === 'mouseover') {
        TooltipText.value = 'Horas'
        isToolTipVisible.value = true
    }
    if (e.eventType === 'mouseout') {
        TooltipText.value = ''
        isToolTipVisible.value = false
    }
  }
  if (e.rowType === 'header'  && e.column.dataField === 'property1'){
    TooltipTarget.value = e.cellElement
    if (e.eventType === 'mouseover') {
        TooltipText.value = 'Facturable'
        isToolTipVisible.value = true
    }
    if (e.eventType === 'mouseout') {
        TooltipText.value = ''
        isToolTipVisible.value = false
    }
  }
  if (e.rowType === 'header'  && e.column.dataField === 'property2'){
    TooltipTarget.value = e.cellElement
    if (e.eventType === 'mouseover') {
        TooltipText.value = 'en Terreno'
        isToolTipVisible.value = true
    }
    if (e.eventType === 'mouseout') {
        TooltipText.value = ''
        isToolTipVisible.value = false
    }
  }
}

function onSaving() {
  authStore.setIsExpanding(props.gridinstance.instance.totalCount())
}

function allowEdicion(e) {
  return !e.row.data.autorizada
}


function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}


function upedateamos() {
  let ds = props.gridinstance.instance
  ds.refresh()
  if (props.onDonutRefresh) props.onDonutRefresh()
}


const cbTareasLoad = new CustomStore({
    key: 'ta_Id',
    loadMode: 'raw',
    load: async () => {
      const tareas = await catalogStore.ensureTareas()
      // getFilter() de abajo espera ta_ProjectId/ta_Exclusive/ta_UserId en
      // cada opción (para decidir si es "genérica sin restricción") - los
      // imputables de catalog.js no traen esos campos, así que sin esto
      // quedarían filtrados y la tarea se volvería a ver en blanco.
      const imputables = catalogStore
        .getImputablesOptions(props.templateData.data.ts_ProjectId).options
        .map((op) => ({ ...op, ta_ProjectId: null, ta_Exclusive: null, ta_UserId: null }))
      return [...tareas, ...imputables]
    },
  })

function getFilter(e) {
  let devuelve = ''
  let numeroUsuario = authStore.userId
  // let projectExclusive = [204,205,379,386,443]
  if (e.data)

    // if (projectExclusive.includes(e.data.ts_ProjectId)) 
    if ( props.templateData.data.generico)
      // Se suma la 3ra condición (ta_ProjectId + ta_UserId) para que una tarea
      // creada "para el proyecto" y "exclusiva de este usuario" no desaparezca
      // solo porque el proyecto también tiene otra tarea con ta_Exclusive seteado.
      devuelve = [
        [['ta_Exclusive','=',e.data.ts_ProjectId],'and',['ta_UserId','=',null]],
        'or',
        [['ta_Exclusive','=',e.data.ts_ProjectId],'and',['ta_UserId','=',numeroUsuario]],
        'or',
        [['ta_ProjectId','=',e.data.ts_ProjectId],'and',['ta_UserId','=',numeroUsuario]]
      ]
    else
      devuelve = [
        [['ta_ProjectId','=',null],'and',['ta_Exclusive','=',null]],
        'or',
        [['ta_ProjectId','=',e.data.ts_ProjectId]]
      ]
  return devuelve
}

const cbTareas = (e) => ({
  store: cbTareasLoad,
  filter: e ? getFilter(e) : null
})


const detailStore = new CustomStore({
  key: 'ts_Id',
  byKey: async (keyVal) => {
      const tarea = catalogStore.getTareaById(keyVal)
      if (tarea) return [tarea]
      // Fallback al backend si no está en cache
      const result = await tokenService.get('Tarea/' + keyVal)
      return result.data || result
    },
  load: async () => {
    let fec = props.hoy.toISOString().split('T')[0]
    await timesStore.ensureRange(fec, fec)
    // D2: reconstruye el ID sintético ("pi_<id>"/"tn_<id>") para que el
    // DxLookup de la columna Tarea pueda resolver el nombre - si no, estas
    // filas vuelven con tareaId null y se ven con la tarea en blanco.
    return timesStore.getDayData(fec, 0).map((row) => ({
      ...row,
      tareaId: catalogStore.encodeTareaId(row)
    }))
  },
  update: async (key) => {
    let tiempoHoras = ''
    if (tiempoDecimal) {
      tiempoHoras = Math.floor(updateObject.value.tiempoInt).toString().padStart(2,'0') + ':' +
      (Math.floor((updateObject.value.tiempoInt-Math.floor(updateObject.value.tiempoInt))*60)).toString().padStart(2,'0')
    } else {
      if (updateObject.value.tiempo instanceof Date) {
        const hours = updateObject.value.tiempo.getHours().toString().padStart(2, '0')
        const minutes = updateObject.value.tiempo.getMinutes().toString().padStart(2, '0')
        tiempoHoras = `${hours}:${minutes}`
      } else if (typeof updateObject.value.tiempo === 'string') {
        tiempoHoras = updateObject.value.tiempo
      } else {
        tiempoHoras = '00:00'
      }
    }

    // D2: decodifica el ID sintético ("pi_<id>"/"tn_<id>") a los campos que
    // espera el backend - si se manda tal cual ("pi_5") en tareaId, se guarda
    // como texto en una columna numérica y corrompe la fila.
    const decoded = catalogStore.decodeTareaId(updateObject.value.tareaId)
    var newBody = {
      tareaId: decoded.tareaid,
      tipoImputacion: decoded.tipoImputacion,
      presupuestoItemId: decoded.presupuestoItemId,
      tareaNoPresupuestadaId: decoded.tareaNoPresupuestadaId,
      minutos: tiempoHoras,
      desc: updateObject.value.tareadesc,
      property1: updateObject.value.property1,
      property2: updateObject.value.property2,
      tsId: key
    }

    if (siTareaId.value) {
      const data = await detailStore.byKey(updateObject.value.tareaId)
      if (data && data.length > 0) {
        newBody.property1 = data[0].taProperty1
        newBody.property2 = data[0].taProperty2
      }
    }
    await tokenService.put('update', newBody)
    timesStore.invalidateDay(props.hoy.toISOString().split('T')[0])
    upedateamos()
  },
  insert: async (value) => {
    let tiempoHoras = ''
    if (tiempoDecimal) {
      tiempoHoras = Math.floor(value.tiempoInt).toString().padStart(2,'0') + ':' +
      (Math.floor((value.tiempoInt-Math.floor(value.tiempoInt))*60)).toString().padStart(2,'0')
    } else {
      if (value.tiempo instanceof Date) {
        const hours = value.tiempo.getHours().toString().padStart(2, '0')
        const minutes = value.tiempo.getMinutes().toString().padStart(2, '0')
        tiempoHoras = `${hours}:${minutes}`
      } else if (typeof value.tiempo === 'string') {
        tiempoHoras = value.tiempo
      } else {
        tiempoHoras = '00:00'
      }
    }

    const decoded = catalogStore.decodeTareaId(value.tareaId)
    let newBody = {
      usercognito: value.ts_UserCognito,
      userId: authStore.userId,
      fecha: value.ts_Fecha,
      projectid: value.ts_ProjectId,
      tipo: value.ts_Tipo,
      tareaid: decoded.tareaid,
      tipoImputacion: decoded.tipoImputacion,
      presupuestoItemId: decoded.presupuestoItemId,
      tareaNoPresupuestadaId: decoded.tareaNoPresupuestadaId,
      desc: value.tareadesc,
      property1: value.property1,
      property2: value.property2,
      minutos: tiempoHoras
    }

    const data = await detailStore.byKey(value.tareaId)
    if (data && data.length > 0) {
      newBody.property1 = data[0].taProperty1
      newBody.property2 = data[0].taProperty2
    }
    await tokenService.post('Times', newBody)
    timesStore.invalidateDay(props.hoy.toISOString().split('T')[0])
    upedateamos()
  },
  remove: async (key) => {
    await tokenService.delete('Times/' + key)
    timesStore.invalidateDay(props.hoy.toISOString().split('T')[0])
    upedateamos()
  }
})

const dataSource = new DataSource({
  store: detailStore,
  filter: [
    ['ts_ProjectId', '=', props.templateData.data.ts_ProjectId],
    'and',
    ['ts_Tipo', '=', props.templateData.data.ts_Tipo]
  ]
}) 

function updateRow(e) { 
  siTareaId.value = Object.prototype.hasOwnProperty.call(e.newData,'tareaId')
    // detailStore.byKey(e.newData.tareaId)
    //   .then(data => {
    //     ver.newData.property1 = data[0].taProperty1
    //     ver.newData.property2 = data[0].taProperty2
    //   })
  if (!e.cancel) {
      for (var property in e.oldData) {
        if (!Object.prototype.hasOwnProperty.call(e.newData,property)) {
          e.newData[property] = e.oldData[property];
        }    
      }
      updateObject.value = e.newData
      
      if (typeof updateObject.value.tareaId === 'object')
        updateObject.value.tareaId = updateObject.value.tareaId.taID
  }  
}

function onRowRemoving() {
  authStore.setIsExpanding(props.gridinstance.instance.totalCount())
}

const emit = defineEmits(['sumaSelected'])

// Manejador de selección en el detail
// const cambioSeleccion = (e) => {
//   emit('cambioSeleccion', {
//     masterRowKey: props.masterRowKey,
//     selectedRows: e.component.getSelectedRowsData()
//   })
// }

function selectionChanged(e) {
  // console.log(myDataGrid.value.instance.getSelectedRowKeys())
  // if (e.currentSelectedRowKeys.length > 0)
  //   emit('sumaSelected', e.selectedRowsData)
  // else
  //   emit('restaSelected', e.currentDeselectedRowKeys)
  // console.log(e)
  // emit('sumaSelected', myDataGrid.value.instance.getSelectedRowsData())
  emit('sumaSelected', e.currentSelectedRowKeys, e.currentDeselectedRowKeys, e.selectedRowsData)
  // emit('cambioSeleccion', {
  //   masterRowKey: 308,
  //   selectedRows: e.component.getSelectedRowsData()
  // })
}

</script>

<style>
.dx-datagrid .dx-link[aria-label="Save"] {
  color: green;
}
.dx-datagrid .dx-link[aria-label="Delete"] {
  color: red;
}
.dx-datagrid .dx-link[aria-label="Edit"] {
  color: blue;
}
.dx-datagrid-rowsview .dx-row > .dx-master-detail-cell {  
  padding: 0px 0px 0px 0px;
}

.grid-class {
    font-size: 0.9rem;
}

</style>